import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'
import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/24/solid'
import { OfferEntry as OfferEntryType } from '../../../../../types/Controlling/OfferEntry'
import { Type } from '../../../../../types/Controlling/Offer'
import { formatEUR, getPrettyDate } from '../../../../../utility'
import useGetOfferEntryName from '../../../../hooks/Controlling/useGetOfferEntryName'
import Modal from '../../../../UI/Modal/Modal'
import EntryMask from '../../AddOffer/Entries/EntryMask'
import { useState } from 'react'
import PDFViewer from '../../../../UI/PDFViewer/PDFViewer'
import { crud } from '@think-internet/zeus-frontend-package'
import useToast from '../../../../hooks/useToast'

type Props = {
  entry: OfferEntryType
  pull: () => void
}

const Offer: React.FC<Props> = ({ entry, pull }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const getOfferEntryName = useGetOfferEntryName()
  const [show, setShow] = useState(false)
  const [data, setDate] = useState<OfferEntryType>({ ...entry })
  const offerEntryFeature = crud.use(props.CONTROLLING_OFFER_ENTRY)
  const toast = useToast()

  const toggle = () => setShow(!show)

  const set = (key: keyof OfferEntryType) => (value: any) => setDate({ ...data, [key]: value })

  const saveEntry = async () => {
    const status = await offerEntryFeature.update(data)
    if (status) {
      toggle()
      pull()
    } else {
      toast(t.controlling.offer.entry.edit.error)
    }
  }

  return (
    <>
      <div className={`flex p-1 items-center`}>
        <div className="w-[20px]">
          {entry.offer.type === Type.INCOME && <ArrowUpIcon className="w-4 h-4 fill-green" />}
          {entry.offer.type === Type.EXPENSE && <ArrowDownIcon className="w-4 h-4 fill-red" />}
        </div>
        <div className="flex-1 hover:underline cursor-pointer" onClick={toggle}>
          {getOfferEntryName(entry)}
        </div>
        <div className="flex-1">{`${entry.offer.type === Type.EXPENSE ? '- ' : ''}${formatEUR(entry.amount)}`}</div>
        <div className="flex-1">{t.controlling.offer.interval[entry.interval]}</div>
        <div className="flex-1">{getPrettyDate(new Date(entry.scheduledDate))}</div>
      </div>
      <Modal show={show} large onConfirm={saveEntry} onClose={toggle} title={t.controlling.offer.entry.view.title}>
        <div className="flex gap-3">
          <div className="flex-1">
            <EntryMask data={data} set={set} />
          </div>
          <div className="flex-1">
            <PDFViewer url={data.offer.fileURL} />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default Offer
